import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEditHostpital } from "../../hooks/hospitals/useEditHospital";
import { useGetDistrict } from "../../hooks/useGetDistrict";
import { FormProvider, useForm } from "react-hook-form";
import Closebtn from "../assests/Closebtn";
import FullscreenLoader from "../loadings/FullscreenLoader";
import ChooseFile from "./ChooseFile";
import InputField from "../InputFields/InputField";
import FasttagToggle from "../FasttagRevenue/FasttagToggle";
import TextArea from "../InputFields/TextArea";
import SelectField from "../InputFields/SelectField";
import { toast } from "react-toastify";
import { useHospitalDocuments } from "../../hooks/hospitals/useHospitalDocuments";
import UploadFiles from "../fileuploads/UploadFiles";
import PropTypes from "prop-types";

function HospitalEditForm({ hospitalDetails }) {
  const { id } = useParams();
  const { data: hospitalDocuments, isLoading: documentLoading } =
    useHospitalDocuments(id);
  const [toggleFasttag, setToggleFasttag] = useState(false);
  const [fileURL, setFileUrl] = useState("");
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);

  const { mutate, isLoading } = useEditHostpital();
  // const [document1, setDocument1] = useState("");
  // const [document2, setDocument2] = useState("");
  // const [document3, setDocument3] = useState("");
  // const handleFileKeyDoc1 = (filekey) => {
  //   setDocument1(filekey);
  // };
  // const handleFileKeyDoc2 = (filekey) => {
  //   setDocument2(filekey);
  // };
  // const handleFileKeyDoc3 = (filekey) => {
  //   setDocument3(filekey);
  // };
  // const selectedHospital = useSelectedHospital(
  //   (state) => state.selectedHospital
  // );
  const { data: districts = [], isLoading: districtLoading } = useGetDistrict();
  const districtOptions = districts?.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  // const locations = useLocation();
  // const patharray = locations.pathname.split("/");

  const methods = useForm();
  // const control = methods.control;
  const navigate = useNavigate();

  useEffect(() => {
    methods.reset({
      fastTagcount: toggleFasttag ? hospitalDetails?.fastTag?.count || 5 : 0,
      fasttagPrice: toggleFasttag ? hospitalDetails?.fastTag?.price : 0,
    });
  }, [toggleFasttag]);

  useEffect(() => {
    if (hospitalDocuments?.length > 0) {
      setFile1({
        name: hospitalDocuments[0]?.name,
        key: hospitalDocuments[0]?.key,
        id: hospitalDocuments[0]?.id,
      });
      setFile2({
        name: hospitalDocuments[1]?.name,
        key: hospitalDocuments[1]?.key,
        id: hospitalDocuments[1]?.id,
      });
      setFile3({
        name: hospitalDocuments[2]?.name,
        key: hospitalDocuments[2]?.key,
        id: hospitalDocuments[2]?.id,
      });
    }
    if (hospitalDetails) {
      console.log("Hospital details", hospitalDetails);

      setFileUrl(hospitalDetails?.logo);
      const fastTag = hospitalDetails?.fastTag?.enabled;
      setToggleFasttag(fastTag);
      const districtId = hospitalDetails?.district_id;
      const district = districtOptions?.find(
        (item) => item.value === districtId
      );

      const billingDistrictId = hospitalDetails?.district_id;
      const billingDistrict = districtOptions?.find(
        (item) => item.value === billingDistrictId
      );

      methods.reset({
        hospitalName: hospitalDetails?.name,
        email: hospitalDetails?.contact_details?.email,
        phone: hospitalDetails?.contact_details?.mobile,
        fastTagcount: hospitalDetails?.fastTag?.count,
        fasttagPrice: hospitalDetails?.fastTag?.price,
        website: hospitalDetails?.contact_details?.website,
        gstnumber: hospitalDetails?.gst,
        companyName: hospitalDetails?.address?.lineOne,
        street: hospitalDetails?.address?.city,
        address: hospitalDetails?.address?.lineTwo,
        town: hospitalDetails?.address?.city,
        district: district,
        state: hospitalDetails?.address?.state,
        pincode: hospitalDetails?.address?.pincode,
        accountNumber: hospitalDetails?.bank_details?.account_number,
        verifyAccountnumber: hospitalDetails?.bank_details?.account_number,
        accountHoldername: hospitalDetails?.bank_details?.account_holder,
        bankname: hospitalDetails?.bank_details?.bank_name,
        ifsc: hospitalDetails?.bank_details?.ifsc,
        upiid: hospitalDetails?.bank_details?.upi_id,
        billingAccountHoldername: hospitalDetails?.billing_address?.lineOne,

        billingStreet: hospitalDetails?.billing_address?.city,
        billingAddress: hospitalDetails?.billing_address?.lineTwo,
        billingTown: hospitalDetails?.billing_address?.city,
        billingDistrict: billingDistrict,
        billingState: hospitalDetails?.billing_address?.state,
        billingPincode: hospitalDetails?.billing_address?.pincode,
        about: hospitalDetails?.about
      });
    }
  }, [hospitalDetails, methods, hospitalDocuments]);

  const handleFileURL = (fileURLResponse) => {
    setFileUrl(fileURLResponse);
  };

  const onEditHospital = async (data) => {
    if (data.accountNumber === data.verifyAccountnumber) {
      const file1Details = {
        name: file1?.name,
        file: file1?.key || file1?.file,
      };
      const file2Details = {
        name: file2?.name,
        file: file2?.key || file2?.file,
      };
      const file3Details = {
        name: file3?.name,
        file: file3?.key || file3?.file,
      };

      const fileArray = [file1Details, file2Details, file3Details].filter(
        (file) => file.name && file.file
      );
      const hospital = {
        name: data?.hospitalName,
        logo: fileURL,
        location: data?.town,
        address: {
          lineOne: data?.companyName,
          lineTwo: data?.address,
          city: data?.town,
          district: data?.district.value,
          state: data?.state,
          pincode: data?.pincode,
          street: data?.street,
        },
        billing_address: {
          lineOne: data?.billingAccountHoldername,
          lineTwo: data?.billingAddress,
          city: data?.billingTown,
          district: data?.billingDistrict?.value,
          state: data?.billingState,
          pincode: data?.billingPincode,
          street: data?.billingStreet,
        },
        fastTag: {
          enabled: toggleFasttag,
          count: toggleFasttag ? parseInt(data?.fastTagcount) : 0,
          price: toggleFasttag ? parseInt(data?.fasttagPrice) : 0,
        },
        bank_details: {
          account_number: data?.accountNumber,
          account_holder: data?.accountHoldername,
          ifsc: data?.ifsc,
          bank_name: data?.bankname,
          upi_id: data?.upiid,
        },
        contact_details: {
          email: data?.email,
          mobile: data?.phone,
          website: data?.website,
        },
        gst: data?.gstnumber,
        documents: fileArray,
        district_id: data?.district.value,
        about: data?.about,
      };
      // console.log("hospital !!", hospital);
      // console.log(mutate);
      await mutate(
        { id: id, data: hospital },
        {
          onSuccess: () => {
            navigate(`/manage-hospitals/${id}`);
          },
        }
      );
      // methods.reset();
    } else {
      const errorMessage = "Account number mismatch";
      toast.error(errorMessage);
    }
  };
  return (
    <div className="bg-white rounded p-4 mt-3">
      <div className="row">
        <div className="col">
          <h4>Edit Hospital</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <Closebtn />
        </div>
      </div>
      {isLoading || (documentLoading && <FullscreenLoader />)}

      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onEditHospital)}>
          <div className="row mt-4">
            <div className="col-md-8 ms-md-3">
              <ChooseFile handleFileURL={handleFileURL} fileURL={fileURL} />
            </div>
          </div>
          <div className="w-100 mt-4 mt-md-2">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <InputField
                    name="hospitalName"
                    label="Hospital Name"
                    validation={{ required: "Hospital Name is required" }}
                    placeholder=""
                    type="text"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <InputField
                    name="email"
                    label="Contact email"
                    validation={{ required: "Contact email is required" }}
                    placeholder=""
                    type="email"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <InputField
                  name="phone"
                  label="Contact number"
                  validation={{ required: "Contact number is required" }}
                  placeholder=""
                  type="phone"
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="form-group">
                <InputField
                  name="website"
                  label="Hospital Website"
                  type="text"
                  placeholder="Hospital website"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-12">
              <TextArea
                name="about"
                label="About"
                // validation={{ required: "Description is required" }}
                placeholder="Write here.."
                // disabled={isSameAsCompanyAddress}
              />
            </div>
          </div>

          <h4 className="card-title">GSTIN</h4>
          <div className="w-50">
            <InputField
              name="gstnumber"
              label="GST Number"
              placeholder="GST Number"
              type="text"
            />
          </div>

          <h4 className="card-title mt-4">Fast Tag</h4>
          <div className="row">
            <div className="col-md-3">
              <div className="d-flex pt-5">
                <label className="">Enable Fast Tag</label>
                <div className="ms-2">
                  <FasttagToggle
                    setToggleFasttag={setToggleFasttag}
                    toggleFasttag={toggleFasttag}
                  />
                </div>
              </div>
            </div>
            {toggleFasttag && (
              <div className="col-md-4">
                <InputField
                  name="fastTagcount"
                  label="Fasttag Count"
                  // validation={{ required: "Fasttag issues per day is required" }}
                  placeholder="Fasttag issues per day"
                  type="number"
                  disabled={!toggleFasttag}
                  validation={{
                    validate: (value) =>
                      Number(value) >= 5 ||
                      "Value must be greater than or equal to 5",
                  }}
                  minValue={5}
                />
              </div>
            )}
            {toggleFasttag && (
              <div className="col-md-4">
                <InputField
                  name="fasttagPrice"
                  label="Fasttag Price"
                  // validation={{ required: "Fasttag issues per day is required" }}
                  placeholder="Fasttag Price"
                  type="price"
                  disabled={!toggleFasttag}
                />
              </div>
            )}
          </div>

          <div className="row mt-4">
            {/* <div className="col-md-6">
                    <div className="form-group">
                      <label>Choose Percentage of Profit</label>
                      <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={option}
                      />
                    </div>
                  </div> */}
            {/* <div className="col-md-6">
                    <div className="form-group">
                      <label>Fast tag Issue Per Day</label>
                      <Select
                      // defaultValue={selectedOption}
                      // onChange={setSelectedOption}
                      // options={option}
                      />
                    </div>
                  </div> */}
          </div>

          <h4 className="card-title mt-1">Hospital Location</h4>
          <div className="row">
            <div className="col-md-4">
              <InputField
                name="companyName"
                label="Hospital Name"
                validation={{ required: "Hospital name is required" }}
                placeholder="Hospital Name"
                type="text"
              />
            </div>

            <div className="col-md-8">
              <InputField
                name="street"
                label="Street"
                validation={{ required: "Street is required" }}
                placeholder="Area / Street / Sector"
                type="text"
              />
            </div>
          </div>

          <div className="form-group mt-3">
            <TextArea
              name="address"
              label="Address"
              validation={{ required: "Address is required" }}
              placeholder="Enter Address"
            />
          </div>

          <div className="row">
            <div className="col-md-7">
              <div className="form-group">
                <InputField
                  name="town"
                  label="Town"
                  validation={{ required: "Town is required" }}
                  placeholder="Town"
                  type="text"
                />
              </div>
            </div>

            <div className="col-md-5">
              <div className="form-group">
                {/* <InputField
                        name="district"
                        label=""
                        validation={{ required: "District is required" }}
                        placeholder="District"
                        type="text"
                      /> */}

                <SelectField
                  options={districtOptions || []}
                  label="District"
                  isLoading={districtLoading}
                  name="district"
                  isMultiSelect={false}
                  placeholder="Select District"
                  validationMessage="District is required"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7">
              <div className="form-group">
                <InputField
                  name="state"
                  label="State"
                  validation={{ required: "State is required" }}
                  placeholder="State"
                  type="text"
                />
              </div>
            </div>

            <div className="col-md-5">
              <div className="form-group">
                <InputField
                  name="pincode"
                  label="Pincode"
                  validation={{ required: "Pincode is required" }}
                  placeholder="Pincode"
                  type="text"
                />
              </div>
            </div>
          </div>

          <h4 className="card-title mt-3">Add Bank Account</h4>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="accountNumber"
                  label="Account Number"
                  validation={{ required: "Account Number is required" }}
                  placeholder="Account Number"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="verifyAccountnumber"
                  label="Verify Account Number"
                  validation={{ required: "Account Number is required" }}
                  placeholder="Verify Account Number"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="accountHoldername"
                  label="Account Holder Name"
                  validation={{
                    required: "Account Holder Name is required",
                  }}
                  placeholder="Account Holder Name"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="bankname"
                  label="Bank Name"
                  validation={{ required: "Bank name is required" }}
                  placeholder="Bank name"
                  type="text"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <InputField
                  name="ifsc"
                  label="IFSC Code"
                  validation={{ required: "IFSC Code is required" }}
                  placeholder="IFSC"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="form-group">
                <InputField
                  name="upiid"
                  label="UPI ID"
                  // validation={{ required: "IFSC Code is required" }}
                  placeholder="Upi id (optional)"
                  type="text"
                />
              </div>
            </div>
          </div>
          <h4 className="card-title mt-3">Billing Address</h4>

          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <InputField
                  name="billingAccountHoldername"
                  label="Account Holder Name"
                  validation={{
                    required: "Account Holder Name is required",
                  }}
                  placeholder="Account Holder Name"
                  type="text"
                  // disabled={isSameAsCompanyAddress}
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="form-group">
                <InputField
                  name="billingStreet"
                  label="Location"
                  validation={{ required: "Street is required" }}
                  placeholder="Area / Street / Sector"
                  type="text"
                  // disabled={isSameAsCompanyAddress}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <TextArea
              name="billingAddress"
              label="Address"
              validation={{ required: "Address is required" }}
              placeholder="Enter Address"
              // disabled={isSameAsCompanyAddress}
            />
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="billingTown"
                  label="Town"
                  validation={{ required: "Town is required" }}
                  placeholder="Town / City"
                  type="text"
                  // disabled={isSameAsCompanyAddress}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <SelectField
                  options={districtOptions || []}
                  label="District"
                  isLoading={districtLoading}
                  name="billingDistrict"
                  isMultiSelect={false}
                  placeholder="Select District"
                  validationMessage="Billing District is required"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="billingState"
                  label="State"
                  validation={{ required: "State is required" }}
                  placeholder="State"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <InputField
                  name="billingPincode"
                  label="Pincode"
                  validation={{ required: "Pincode is required" }}
                  placeholder="Pincode"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="edit-hospital">
              <h4>Related Documents</h4>
              <p>upload related documents to complete the process</p>
            </div>
            <div className="row mt-4 pb-5">
              <div className="col-md-4 mt-2">
                <UploadFiles
                  // handleFileKey={handleFileKeyDoc1}
                  fileDetails={file1}
                  setFileDetails={setFile1}
                />
              </div>
              <div className="col-md-4 mt-2">
                <UploadFiles
                  // handleFileKey={handleFileKeyDoc2}
                  fileDetails={file2}
                  setFileDetails={setFile2}
                />
              </div>
              <div className="col-md-4 mt-2">
                <UploadFiles
                  // handleFileKey={handleFileKeyDoc3}
                  fileDetails={file3}
                  setFileDetails={setFile3}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="settings-btns col-md-6 col-sm-12">
              <button
                type="submit"
                className="btn btn-outline-primary"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              &nbsp;&nbsp;
            </div>

            <div className="settings-btns col-md-6 col-sm-12 mt-md-0 mt-2">
              <div className="d-flex justify-content-md-end justify-content-center">
                <button
                  type="submit"
                  className="btn btn-secondary btn-main-secondary"
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button
                  type="submit"
                  className="border-0 btn-primary btn-main-primary text-white"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

HospitalEditForm.propTypes = {
  hospitalDetails: PropTypes.object,
};

export default HospitalEditForm;
